if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends DetailsDisclosure {
    constructor() {
      super();
      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        closeButton: this.querySelector('.share-button__close'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        copyButton: this.querySelector('.share-button__copy'),
        errorMessage: this.querySelector('.share-button__error'),
      };
      this.updateUrl(this.elements.urlInput.value);
      this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
      this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      this.elements.closeButton.addEventListener('click', this.close.bind(this));
      if (navigator.share) {
        this.mainDetailsToggle.hidden = true;
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', this.share.bind(this));
      }
    }

    async share() {
      try {
        await navigator.share({
          url: this.urlToShare,
          title: this.dataset.shareTitle || document.title,
          ...(this.dataset.shareText ? { text: this.dataset.shareText } : {}),
        });
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.elements.shareButton.classList.add('hidden');
        this.mainDetailsToggle.hidden = false;
        this.mainDetailsToggle.open = true;
        this.elements.shareSummary.focus();
      }
    }

    toggleDetails() {
      if (!this.mainDetailsToggle.open) {
        this.elements.errorMessage?.classList.add('hidden');
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.closeButton.classList.add('hidden');
        this.elements.shareSummary.focus();
      }
    }

    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.urlToShare);
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.elements.successMessage.classList.remove('hidden');
        this.elements.closeButton.classList.remove('hidden');
        this.elements.errorMessage?.classList.add('hidden');
        this.elements.closeButton.focus();
      } catch {
        this.elements.urlInput.focus();
        this.elements.urlInput.select();
        this.elements.errorMessage?.classList.remove('hidden');
      }
    }

    updateUrl(url) {
      const cleanUrl = new URL(url, location.origin);
      const variant = cleanUrl.searchParams.get('variant');
      cleanUrl.search = '';
      cleanUrl.hash = '';
      if (variant) cleanUrl.searchParams.set('variant', variant);
      this.urlToShare = cleanUrl.href;
      this.elements.urlInput.value = this.urlToShare;
    }
  });
}
